// extracted by mini-css-extract-plugin
export default {"grid":"_XUQgOk","donutSize":"sc4x4sd","error":"RqQrWZi","noResults":"DZunsBO"};